import { IFrameStore } from '@rift/service/validation/database/syncrecording/IFrameStore';
import { IObjectStore } from '@shared/service/Indexeddb/IObjectStore';

export interface IDatabaseRegisterFramesStore extends IFrameStore {
}

export class DatabaseRegisterFramesStore implements IObjectStore {
    public static readonly keyPath: string = 'id';
    public static readonly recordingIdBlockIndex: string = 'RecordingIdBlockIndex';
    public static readonly recordingIdFrameNumberIndex: string = 'RecordingIdFrameNumberIndex';
    public static readonly recordingIdIndex: string = 'RecordingIdIndex';
    public static readonly storeDisplayName: string = 'Counts';
    public static readonly storeName: string = 'register';

    public get storeName(): string {
        return DatabaseRegisterFramesStore.storeName
    };

    public static toInterface(): IDatabaseRegisterFramesStore {
        return {
            storeName: this.storeName,
            keyPath: this.keyPath,
            recordingIdFrameNumberIndex: this.recordingIdFrameNumberIndex,
            recordingIdIndex: this.recordingIdIndex,
            recordingIdBlockIndex: this.recordingIdBlockIndex,
        } as IDatabaseRegisterFramesStore;
    }

    public createStores(db: IDBDatabase): void {
        const store: IDBObjectStore = db.createObjectStore(DatabaseRegisterFramesStore.storeName, { keyPath: DatabaseRegisterFramesStore.keyPath, autoIncrement: true });
        store.createIndex(DatabaseRegisterFramesStore.recordingIdFrameNumberIndex, ['recordingId', 'frameNumber'], { unique: true });
        store.createIndex(DatabaseRegisterFramesStore.recordingIdBlockIndex, ['recordingId', 'block']);
        store.createIndex(DatabaseRegisterFramesStore.recordingIdIndex, 'recordingId');
    }
}
